import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {size} from 'lodash';
import template from './../../templates/PageLayout/CentralHub.rt'
import headerTemplate from './../../templates/PageLayout/GenericHeader.rt';
import footerTemplate from './../../templates/PageLayout/GenericFooter.rt';
import {modifyPageLayoutComponents} from "./index";
import * as actions from './../../actions';
import {AccessRights} from '../../schemas/accessRightsModel';
import {asUserId} from "../../reducers/asCustomer";
import misc from './../../misc';
import * as backend from './../../utilities/backend';
import {hasSubscriptions} from "../../utilities/subscriptionFunctions";
import {
  getAuthSubDomain,
  hardCodeIsDeStefano,
  hardCodeIsEncore, hardCodeIsFabricator, hardCodeIsKitchenMagic,
  hardCodeIsNhance
} from "../../constants/fabricatorHardcode";
import {getFabricatorSubscriptions} from "../NewScope/newScopeActions";
import {IS_QKB_PRODUCTION} from "../../utilities/backend";

class CentralHubControl extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      disallowQuoteButtonFor: [] // "kitchen", "bathroom", etc.
    }
  }

  async componentDidMount() {
    if ((this.props.isClient || this.props.isEmployee) && this.props.auth.subdomainFabricatorId) {
      const subscriptions = await this.props.getFabricatorSubscriptions(this.props.auth.subdomainFabricatorId);
      // console.log("subscriptions", subscriptions);
      if (subscriptions && subscriptions.fabricatorData && subscriptions.fabricatorData.settings.toolSettings) {
        let disallowQuoteButtonFor = [];
        Object.keys(subscriptions.fabricatorData.settings.toolSettings).forEach((visualizerName) => {
          if (subscriptions.fabricatorData.settings.toolSettings[visualizerName].visualizerOnly) {
            disallowQuoteButtonFor.push(visualizerName);
          }
        });
        if (disallowQuoteButtonFor.length) {
          this.setState({ disallowQuoteButtonFor });
        }
      }
    }
    // $(document).on('hub_reload', this.hubReload.bind(this));
  }

  componentWillUnmount() {
    // $(document).off('hub_reload');
  }

  // Hub icons not showing due to race condition with react-redux with requireAuth on entering central hub
  // having a click event that triggers a changeLocation('/') (such as clicking on the hub icon) triggers a refresh
  // to get the same level of force programatically we have to trigger 2 changeLocation('/') calls
  // hubReload() {
  //   this.props.go('/');
  //   this.props.go('/');
  // }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.auth.authenticated) {
      this.context.router.replace('/');
    }

    if (nextProps.willSetCurrentUser && this.props.willSetCurrentUser !== nextProps.willSetCurrentUser) {
      this.forceUpdate();
    }
  }

  isAmericanImport = () => {
    const { asCustomer, auth } = this.props;
    let fabricatorId = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    switch (fabricatorId) {
      case 140460: //American Import
      case 155479: //American Standard 2020
        return true;
    }
    return false;
  }

  shouldOpenLookJourney = (subDomain) => {
    return this.props.isEncore || hardCodeIsNhance(subDomain) || hardCodeIsKitchenMagic(subDomain)
  }

  shouldOpenProductJourney = (subDomain) => {
    return hardCodeIsFabricator(subDomain, ["materpol"])
  }

  goToNewQuote = (isVisualizer = false, subUrl = "", isOfflineMode = false) => {
    let url = '';
    const {auth, AR, language, asCustomer, isClient, isSuperAdmin} = this.props;
    let userId = auth.userId;
    let subDomain = auth.subDomain || 'master';

    //console.log(999, asCustomer);
    if (asCustomer && asCustomer.activeEntity) {
      const {activeEntity} = asCustomer;
      subDomain = activeEntity.subDomain;
      userId = activeEntity.id;

      if (!size(subDomain)) {
        alert('Current selected fabricator doesn\'t have a subDomain set.');
        return;
      }
    }

    // if (window.location.port === '9005') { // local debug
    //   window.open(`http://${subDomain}.gfd.us/${subUrl}`, '_blank');
    //   return;
    // }

    const parts = window.location.hostname.split('.');
    let hostNameOnly = parts.slice(-2).join('.');
    if (hostNameOnly.toLowerCase() === "quotegranite.com") {
      hostNameOnly = "quotecountertops.com";
      if (!subDomain || subDomain === "") {
        subDomain = "app";
      }
    }
    if(backend.getManaging() == "KitchenDB") {
      if(hostNameOnly.toLowerCase().includes('quotekitchenandbath')) {
        hostNameOnly = "quotecountertops.com";
        if (!subDomain || subDomain === "") {
          subDomain = "app";
        }
      } else {
        hostNameOnly = "granitefabricatorsdirect.com";
      }
    }

    if (subUrl === "dealer") { //hard coded per alan, until we have time to do it right
      //url = `https://americanstandard_154e20.${hostNameOnly}/visualizer?nav=product&u=${userId}&d=1#/shop`;
      url = IS_QKB_PRODUCTION
        ? `https://${hostNameOnly}/visualizer?mode=dashboard&u=${userId}&ef=iW86c6GGnXidooyaIgfWLA&d=1&nav=product#/shop`
        : `https://${hostNameOnly}/visualizer?mode=dashboard&u=${userId}&ef=MSSKqCbBh00zeZKSr9Go0Q&d=1&nav=product#/shop`;
      window.open(url, '_blank');
      return;
    }

    url = `${window.location.protocol}//${subDomain}.${hostNameOnly}/${subUrl}`;

    if (isVisualizer) {
      if (asCustomer && asCustomer.activeEntity && asCustomer.activeEntity.canAddLabor) {
        url += "?can_add_labor=true&from_dashboard=true&mode=dashboard";
      } else if(AR.isFabUser() || AR.isFabAdmin() || AR.isFabMaster() || AR.isSiteAdmin(true)) {
        url += "?mode=dashboard"
      }
    } else if(AR.isFabUser() || AR.isFabAdmin() || AR.isFabMaster() || AR.isSiteAdmin(true)) {
      url += "?mode=dashboard";
    }
    if (isSuperAdmin) {
      url += `${(url.includes('?') ? "&" : "?")}a=1`;
    }
    if(!isClient)
    {
      url += `${(url.includes('?') ? "&" : "?")}p=${userId}`;
    }
    if (!hardCodeIsDeStefano(subDomain)) {
      url += `${(url.includes('?') ? "&" : "?")}language=${language}`;
    }
    if (isClient && userId) {
      url += `${(url.includes('?') ? "&" : "?")}u=${userId}`;
    }
    url += isOfflineMode ? `${(url.includes('?') ? "&" : "?")}offlineMode=1` : "";
    if (this.shouldOpenProductJourney(subDomain)) {
      url += `${(url.includes('?') ? "&" : "?")}nav=product`;
    } else if (isVisualizer && this.shouldOpenLookJourney(subDomain)) {
      url += `${(url.includes('?') ? "&" : "?")}nav=look`;
    } else if (backend.IS_LIXIL_SERVERS) {
      url += isVisualizer ? `${(url.includes('?') ? "&" : "?")}nav=look` : `${(url.includes('?') ? "&" : "?")}nav=product`;
    } else {
      url += isOfflineMode
        ? "#/shoppingcart"
        : isVisualizer ? "#/visualizer" : "#/materials";
    }
    window.open(url, '_blank');
  }

  customerClickHandler = () => {
    const {AR, asCustomer, auth} = this.props;
    const {bathroomSubscription, kitchenSubscription} = auth;
    const subType = misc.monads.NN(bathroomSubscription, _ => _.type, '') ||
      misc.monads.NN(kitchenSubscription, _ => _.type, '');
    if (AR.isClient() || subType === 'free') {
      this.props.go(`account?entityId=${asUserId(asCustomer) || auth.userId}&clientType=Client`);
    } else {
      this.props.go('customers');
    }
  }

  getEditProfileUrl = () => {
    const {asCustomer, auth} = this.props;
    return `account?entityId=${asUserId(asCustomer) || auth.userId}&clientType=Client`;
  }

  employeesClickHandler = () => {
    const {AR, asCustomer, auth} = this.props;
    if (!AR.isFabUser() || AR.isFabAdmin() || AR.isFabMaster()) {
      this.props.go('employees');
    } else {
      this.props.go(`account?entityId=${asUserId(asCustomer) || auth.userId}&clientType=Customer`);
    }
  }

  render = template;
}

function mapStateToProps(state) {
  const {auth, asCustomer} = state;
  const AR = AccessRights.get(state);
  const {hasKitchen, hasBathroom, hasFireplace, hasLaundryRoom} = hasSubscriptions(state);

  const subDomain = getAuthSubDomain(auth, asCustomer);
  const isEncore = hardCodeIsEncore(subDomain);
  const isClient = AR.isClient();
  const isEncoreClient = hardCodeIsEncore(subDomain) && isClient;
  const isSuperAdmin = AR.isSiteAdmin(true);

  return {
    auth,
    hideSearch: true,
    hideButtonSave: true,
    hideButtonCancel: true,
    AR,
    willSetCurrentUser: asCustomer.willSetCurrentUser,
    asCustomer,
    hasKitchen,
    hasBathroom,
    hasFireplace,
    hasLaundryRoom,
    language: state.dashboardState.language,
    isEncore,
    isEncoreClient,
    isClient,
    isEmployee: !(AR.isSiteAdmin(false) || AR.isFabAdmin() || AR.isFabMaster()),
    isSuperAdmin
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setSearchTerm: () => {
    },
    go: where => dispatch(actions.changeLocation(where)),
    logout: () => dispatch(actions.logout()),
    getFabricatorSubscriptions: (fabId) => dispatch(getFabricatorSubscriptions(fabId)),
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

const CentralHubControlComponent = connector(CentralHubControl);

export const CentralHubLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(headerTemplate),
  content: CentralHubControlComponent,
  pageFooter: connector(footerTemplate)
});


